import React, { useEffect, useState } from 'react';

import PermissionToRender from '../../../components/Permission/PermissionToRender';
import MapContainer from '../../../components/mapContainer/MapContainer';
import divIcons from '../../../components/leaflet-icons/div-icons';
import { websocket_config } from '../../../constants/wsConfig';
import useStateLiveVehicles from '../../../hooks/useStateLiveVehicles';
import useWsConnection from '../../../hooks/useWsConnection';
import { toast } from 'react-toastify';
import { kdTree, haversineDistance, Coordinate } from './kd-tree';
import { useDashboardStore } from './store/store';
import { useBoundStore } from '../../../stores';
import {
  beltDangerIcon,
  beltOkIcon,
  seatDangerIcon,
  seatOkIcon,
} from '../../../components/leaflet-icons/image-icons';
import Uni from './uni';
import Ayd from './ayd';
const Reports = () => {
  const textPool = useBoundStore((store) => store.textPool);
  const [sortedRoute, setSortedRoute] = useState([]);
  const wsConfig = useBoundStore((state) => state.wsConfig);

  const {
    LRoutes,
    LCards,
    LSeats,
    error,
    LBelts,
    setBeltInfo,
    setSeatInfo,
    setVehicleInfo,
    setCardInfo,
    setLocationInfo,
    setAdress,
    resetInfoState,
    setInfoBarVisible,
    setTypeInfo,
  } = useDashboardStore();
  const center = useDashboardStore((store) => store.center);
  const { greenPolylines, redPolylines } = useDashboardStore(
    (store) => store.multiPolylines,
  );
  const wsConnectionData = {
    stompHeader: {
      login: websocket_config.username,
      passcode: websocket_config.password,
    },
    broker: websocket_config.broker,
    url: wsConfig,
  };
  const [wsData, wsAllData, disconnect, connect, connected] =
    useWsConnection(wsConnectionData);
  const { vehicles, setStateVehicle } = useStateLiveVehicles();
  const sx = {
    fontSize: '80px',
  };
  // const [nearest, setNearest] = useState(null);
  // const kdTreeRef = React.useRef(null);
  // const points = [
  //   { latitude: 52.52, longitude: 13.405 }, // Berlin
  //   { latitude: 48.8566, longitude: 2.3522 }, // Paris
  //   { latitude: 51.5074, longitude: -0.1278 }, // London
  //   { latitude: 40.7128, longitude: -74.006 }, // New York
  //   { latitude: 34.0522, longitude: -118.2437 }, // Los Angeles
  // ];
  // const dimensions = ['latitude', 'longitude'];
  // if (!kdTreeRef.current) {
  //   kdTreeRef.current = new kdTree(points, haversineDistance, dimensions);
  // }

  // const findNearest = () => {
  //   const targetPoint = { latitude: 37.7749, longitude: -122.4194 }; // San Francisco
  //   const nearestPoints = kdTreeRef.current.nearest(targetPoint, 1);
  //   setNearest(nearestPoints);
  // };
  const cardMarkers = {
    items: LCards,
    icon: function (item) {
      return divIcons.card(item);
    },
    position: function (item) {
      return Coordinate.fromString(item.coordinate).getArrCoordinate();
    },
    eventHandlers: {
      click: (event, item) => {
        resetInfoState();
        setTypeInfo('Card');
        setInfoBarVisible(true);
        setCardInfo(item);
        setAdress(item.coordinate);
      },
    },
    markerCluster: false,
    responsivePopup: false,
  };
  const liveMarkers = {
    items: vehicles,

    icon: function (item) {
      return divIcons.car(item);
    },
    position: function (item) {
      return Coordinate.fromObject(item).getArrCoordinate();
    },
    eventHandlers: {
      click: (event, item) => {
        resetInfoState();
        setTypeInfo('Vehicle');
        setInfoBarVisible(true);
        setVehicleInfo(item);
        setAdress(
          new Coordinate(item.latitude, item.longitude).getStrCoordinate(),
        );
      },
    },
    markerCluster: false,
    responsivePopup: false, // is enable only it has popup or tooltip and it is not working without markerCluster
  };

  const routeMarkers = {
    items: LRoutes,
    // tooltip: {
    //   content: ExamplePopup,
    //   props: {
    //     direction: 'bottom',
    //     offset: [0, 5],
    //     opacity: 1,
    //     permanent: false,
    //   },
    // },

    icon: function (item) {
      return divIcons.routeIcon(
        item,
        sortedRoute[LRoutes.length - 1]?.index || LRoutes.length,
        sortedRoute[0]?.index || 1,
      );
    },
    position: function (item) {
      return Coordinate.fromString(item?.coordinate).getArrCoordinate();
    },
    eventHandlers: {
      click: (event, item) => {
        resetInfoState();
        setTypeInfo('Point');
        setInfoBarVisible(true);

        setLocationInfo(item);
        setAdress(item.coordinate);
      },
    },
    markerCluster: false,
    responsivePopup: false,
  };
  const pathPolyline = {
    pathOptions: {
      color: '#3388ff',
      weight: 2,
      stroke: true,
    },
    positions: LRoutes?.map((item) =>
      Coordinate.fromString(item?.coordinate).getArrCoordinate(),
    ),
  };
  const seatMarkers = {
    items: LSeats,
    icon: function (item) {
      return item?.status === 'none' ? seatDangerIcon : seatOkIcon;
    },
    position: function (item) {
      return Coordinate.fromString(item?.coordinate).getArrCoordinate();
    },
    eventHandlers: {
      click: (event, item) => {
        resetInfoState();
        setTypeInfo('Seat');
        setInfoBarVisible(true);

        setSeatInfo(item);
        setAdress(item.coordinate);
      },
    },
    markerCluster: true,
    responsivePopup: false,
  };
  const beltMarkers = {
    items: LBelts,
    icon: function (item) {
      return item?.status === 'none' ? beltDangerIcon : beltOkIcon;
    },
    position: function (item) {
      return Coordinate.fromString(item?.coordinate).getArrCoordinate();
    },
    eventHandlers: {
      click: (event, item) => {
        resetInfoState();
        setTypeInfo('Belt');
        setInfoBarVisible(true);

        setBeltInfo(item);
        setAdress(item.coordinate);
      },
    },
    markerCluster: true,
    responsivePopup: false,
  };

  const redPolylineProps = {
    pathOptions: {
      color: '#ff0000',
      weight: 5,
      stroke: true,
    },
    eventHandlers: {
      click: (event, item) => {
        console.log(event, 'item');
      },
    },
    positions: greenPolylines?.map((item) =>
      item.map((item) =>
        Coordinate.fromString(item?.coordinate).getArrCoordinate(),
      ),
    ),
  };

  const greenPolylineProps = {
    pathOptions: {
      color: '#249c44',
      weight: 5,
      stroke: true,
    },
    eventHandlers: {
      click: (event, item) => {
        findNearest();
        console.log(nearest, 'nearest');
      },
    },
    positions: redPolylines.map((item) =>
      item.map((item) =>
        Coordinate.fromString(item?.coordinate).getArrCoordinate(),
      ),
    ),
  };
  useEffect(() => {
    const routes = LRoutes?.sort((a, b) => (a.index > b.index ? 1 : -1));
    setSortedRoute(routes);
  }, [LRoutes]);
  useEffect(() => {
    setStateVehicle(wsData);
  }, [wsData]);

  useEffect(() => {
    if (error !== '') {
      toast.error(error);
    }
  }, [error]);

  return (
    <div className="w-screen h-dvh relative">
      <PermissionToRender instanceCanView={['amir-al0']}>
        <MapContainer
          markers={connected ? [liveMarkers] : [beltMarkers, seatMarkers]}
          mapProps={{ center: center }}
        />
        <Uni connect={connect} vehicles={vehicles} disconnect={disconnect} />
      </PermissionToRender>
      <PermissionToRender instanceCanView={['amir-tr0']}>
        <Ayd connect={connect} vehicles={vehicles} disconnect={disconnect} />
        <MapContainer
          mapProps={{
            center: center,
          }}
          markers={connected ? [liveMarkers] : [routeMarkers, cardMarkers]}
          polylineProps={
            LRoutes?.length > 0
              ? [/* redPolylineProps, greenPolylineProps */ pathPolyline]
              : []
          }
        />
      </PermissionToRender>
    </div>
  );
};

export default Reports;
